import { MODULE_PREFIX_MAP } from "@/store";
import { SET_RESET_MAP_ICONS } from "@/store/mutations.type";
import store from "@/store";
import { pageTrackerLogger } from "@/common/pageTracker";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

class ClearControl {
  _store = store;
  _container = null;
  _button = null;
  _map = null;

  constructor() {
    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group hyp-clear";
    this._container.addEventListener("contextmenu", (e) => e.preventDefault());

    this._button = document.createElement("button");
    this._button.id = "map-clear-all-button";
    this._button.className = "mapboxgl-ctrl-icon hyp-clear-button";
    this._button.addEventListener("click", () => {
      this.clearDataLayers().then(() => {
        this._button.classList.replace(
          "hyp-selected-button",
          "hyp-clear-button"
        );
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.map,
          EVENT_ACTIONS.clicked,
          "Clear Map Icons"
        );
      });
    });
    this._container.appendChild(this._button);
  }

  onAdd(map) {
    this._map = map;
    return this._container;
  }

  async clearDataLayers() {
    await this._store.commit(
      MODULE_PREFIX_MAP + SET_RESET_MAP_ICONS,
      new Date()
    );
  }

  handlePageTrackerEvent(category, action, name) {
    let _paq = (window._paq = window._paq || []);
    _paq.push(["trackEvent", category, action, name]);
    pageTrackerLogger(
      "Page Tracker Event " + category + " " + action + " " + name + " logged."
    );
  }
}

export default ClearControl;
